import {
  useBeeswaxAdPosition,
  useBeeswaxEnvironmentTypes,
} from "@/modules/Beeswax/beeswax.hook";

export function useEnvironmentData({
  isEdit,
  areFilters,
}: {
  isEdit: boolean;
  areFilters: Record<string, boolean>;
}) {
  const {
    data: adPosition,
    isLoading: adPositionLoading,
    isFetching: adPositionFetching,
  } = useBeeswaxAdPosition({
    options: { enabled: isEdit && areFilters?.ad_position },
  });
  const {
    data: environmentTypes,
    isLoading: environmentTypesLoading,
    isFetching: environmentTypesFetching,
  } = useBeeswaxEnvironmentTypes({
    options: { enabled: isEdit && areFilters?.environment_type },
  });
  return {
    adPosition,
    domainListLoading: adPositionLoading && adPositionFetching,
    environmentTypes,
    environmentTypesLoading:
      environmentTypesLoading && environmentTypesFetching,
  };
}
